import $ from 'jquery'
import axios from 'axios'
import { Modal } from 'mdb-ui-kit'; // lib
import { PageFlip } from 'page-flip';
import { handlerbarsRenderByName } from '../../shared/handlebars'
import { reverseUrl } from '../../shared'
import { updateLazyLoad } from './lazy-load';

// Const
const catelogPageElement = $('.catelog-page-container')
const productModal = $('#product-detail')
const setting = $('#SETTING').html() ? JSON.parse($('#SETTING').html()) : {}
const currentSite = $('#CURRENT_SITE').html() ? JSON.parse($('#CURRENT_SITE').html()) : null
setting.page_width = setting.page_width || 600
setting.page_height = setting.page_height || 600

const scaleTheLandingPageForMobile = () => {
  function resize() {
    const landingPage = document.getElementById('landing-page');
    const contaoner = document.getElementById('lading-page-box');
    const maxWidth = setting.page_width || 450;
    const maxHeight = setting.page_height || 645;

    let scale;
    let height;
    let width;
    let isMax;

    if (document.body.clientWidth < 600) {
      height = window.innerHeight;
      width = window.innerWidth;
      isMax = width >= maxWidth && height >= maxHeight;
    } else if (document.body.clientWidth < 1200) {
      height = window.innerHeight - 180;
      width = window.innerWidth;
      isMax = false;
    } else {
      height = window.innerHeight - 150;
      width = window.innerWidth - 150;
      isMax = false;
    }

    scale = Math.min(width / maxWidth, height / maxHeight);
    landingPage.style.transform = isMax ? '' : `scale(${scale})`;
    contaoner.style.width = isMax ? '' : maxWidth * scale;
    contaoner.style.height = isMax ? '' : maxHeight * scale;
  }

  window.addEventListener('resize', resize);
  window.onload(resize)
  resize();
}

axios.get(`${reverseUrl('landing:api-landing-page')}${(currentSite ? `?site=${currentSite.id}` : '')}`).then((res) => {
  const { products, pages } = res.data
  // Page content find attach product from virtual dom
  pages.forEach((element, index) => {
    const currentPage = pages[index]
    let pageStyling;
    try {
      pageStyling = JSON.parse(currentPage.content)
    } catch (err) {
      // console.error(err, currentPage.content)
      pageStyling = currentPage.content
    }

    currentPage.image = pageStyling.background
    currentPage.products = []
    pageStyling.products.forEach((style) => {
      const product = products.find((p) => p.id == style.id)
      if (!product) return;
      const styleArray = []
      if (style.top) styleArray.push(`top:${style.top}`)
      if (style.left) styleArray.push(`left:${style.left}`)
      if (style.width) styleArray.push(`width:${style.width}`)
      if (style.height) styleArray.push(`height:${style.height}`)
      currentPage.products.push({
        ...product,
        style: styleArray.join(';'),
      })
    })
  })

  const pageHtml = $(handlerbarsRenderByName('landing-page', { pages }))
  catelogPageElement.html(pageHtml)

  // Bind event to html
  window.addEventListener('resize', scaleTheLandingPageForMobile);
  window.onload(scaleTheLandingPageForMobile)
  scaleTheLandingPageForMobile()

  // Lazy load ready
  updateLazyLoad()

  // https://nodlik.github.io/StPageFlip/
  const pageFlip = new PageFlip(
    document.getElementById('landing-page'),
    {
      width: setting.page_width, // required parameter - base page width
      height: setting.page_height, // required parameter - base page height
      size: 'fixed',
      drawShadow: true,
      // set threshold values:
      minWidth: 315,
      maxWidth: 1000,
      minHeight: 420,
      maxHeight: 1350,
      maxShadowOpacity: 0.5, // Half shadow intensity
      mobileScrollSupport: true, // disable content scrolling on mobile devices
      swipeDistance: 100,
      useMouseEvents: false,
      showCover: true,
    },
  )
  pageFlip.loadFromHTML(document.querySelectorAll('.catelog-page'))
  pageFlip.on('init', () => {})
  document.querySelector('.page-total').innerText = pageFlip.getPageCount();
  document.querySelector('.btn-prev').addEventListener('click', () => {
    pageFlip.flipPrev(); // Turn to the previous page (with animation)
  })
  document.querySelector('.btn-next').addEventListener('click', () => {
    pageFlip.flipNext(); // Turn to the next page (with animation)
  })
  document.querySelector('.btn-side-prev').addEventListener('click', () => {
    pageFlip.flipPrev(); // Turn to the previous page (with animation)
  })
  document.querySelector('.btn-side-next').addEventListener('click', () => {
    pageFlip.flipNext(); // Turn to the next page (with animation)
  })
  // triggered by page turning
  pageFlip.on('flip', (e) => {
    document.querySelector('.page-current').innerText = e.data + 1;
  })

  //will find other liberly
  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);

  var xDown = null;
  var yDown = null;

  function getTouches(evt) {
    return evt.touches // browser API
         || evt.originalEvent.touches; // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) { /*most significant*/
      if (xDiff > 0) {
      /* right swipe */
        pageFlip.flipNext();
      } else {
      /* left swipe */
        pageFlip.flipPrev();
      }
    } else if (yDiff > 0) {
    /* down swipe */
    } else {
    /* up swipe */
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }

  // Open modal
  $('.product-attachment', catelogPageElement).on('click', (e) => {
    e.preventDefault()
    const product = products.find((p) => p.id == $(e.target).data('product'))
    const productHtml = handlerbarsRenderByName('landing-page-product-detail', product)
    productModal.find('.modal-body').html(productHtml)
    productModal.modal('show')
  })
})
